import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { MdOutlinePendingActions, MdImageNotSupported } from 'react-icons/md';
import { FaEye } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../../redux/store';
import { useQueryFetchPages } from '../../../apiQuery/useQueryFetchPages';
import { Btn } from '../../data/Btn';
import Format from '../../../Services/Format';
import Globals from '../../../Globals.json';
import { useSalesTemporaryTotal } from '../useSalesTemporaryTotal';
import * as S from './styles';

export function SalesTemporary() {
  const history = useHistory();
  const { storeActive } = useAppSelector(
    ({ storeMeReducer }) => storeMeReducer.value
  );

  const [vendaDetalhe, setVendaDetalhe] = useState<any>(null);

  const { data } = useQueryFetchPages<any>(
    ['sales-temporary', 'dashboard-card'],
    `${Globals.api.salesTemporary}`,
    {
      page: 1,
      queryParams: {
        store_id: storeActive?.id,
      },
    }
  );

  const vendas = data?.data ?? [];

  // O card mostra a soma do que está em aberto agora, somando todas as páginas
  // do endpoint — não apenas a primeira, que é a exibida na lista abaixo.
  const { total: totalAberto, count: qtdAberto } = useSalesTemporaryTotal(
    storeActive?.id
  );

  const handleViewAll = () => {
    history.push(Globals.paths.CadVendasTemporarias);
  };

  return (
    <S.Container>
      <div className="menu-top">
        <h3>Vendas Temporárias</h3>
        <MdOutlinePendingActions className="icon" size={24} />
      </div>
      <div className="content">
        <span className="total">{Format.formatCurrencyBr(String(totalAberto))}</span>
        <span className="label">
          em {qtdAberto} venda{qtdAberto === 1 ? '' : 's'} em aberto
        </span>
      </div>

      <div className="wrapper">
        {vendas.length > 0 ? (
          vendas.map((venda: any) => (
            <div key={venda.id} className="details">
              <div className="img">
                {venda.image ? (
                  <img
                    src={venda.image}
                    alt={venda.item_description}
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.nextElementSibling?.classList.remove('hidden');
                    }}
                  />
                ) : null}
                <MdImageNotSupported
                  className={venda.image ? 'hidden' : ''}
                  size={18}
                />
              </div>
              <span className="description">
                {venda.item_description ?? `Número ${venda.number ?? '---'}`}
              </span>
              <span className="terminal">Terminal {venda.terminal ?? '---'}</span>
              <span className="qty">Qtd: {venda.sale_qty ?? '---'}</span>
              <span className="total-value">
                {Format.formatCurrencyBr(venda.total)}
              </span>
              <button
                type="button"
                className="view-btn"
                onClick={() => setVendaDetalhe(venda)}
                title="Ver detalhes"
              >
                <FaEye size={14} />
              </button>
            </div>
          ))
        ) : (
          <div className="not-data">Nenhuma venda temporária em aberto.</div>
        )}
      </div>

      <div className="footer-actions">
        <Btn text="Ver todas" variante="secondary" onClick={handleViewAll} />
      </div>

      <Modal show={!!vendaDetalhe} onHide={() => setVendaDetalhe(null)} centered>
        <Modal.Header closeButton>
          <S.DetailHeader style={{ border: 'none', margin: 0, padding: 0 }}>
            <span>
              <span className="terminal-label">Terminal</span>
              <span className="terminal">{vendaDetalhe?.terminal ?? '---'}</span>
            </span>
          </S.DetailHeader>
        </Modal.Header>
        <Modal.Body>
          <S.DetailTable>
            <thead>
              <tr>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>Valor Unitário</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{vendaDetalhe?.item_description ?? '---'}</td>
                <td>{vendaDetalhe?.sale_qty ?? '---'}</td>
                <td>{Format.formatCurrencyBr(vendaDetalhe?.unit_sale_value)}</td>
                <td>{Format.formatCurrencyBr(vendaDetalhe?.total)}</td>
              </tr>
            </tbody>
          </S.DetailTable>

          <S.DetailFooter>
            <div className="footer-item">
              <span className="footer-label">Turno</span>
              <span className="footer-value">
                {vendaDetalhe?.shift ? `Turno ${vendaDetalhe.shift}` : '---'}
              </span>
            </div>
            <div className="footer-item">
              <span className="footer-label">Data</span>
              <span className="footer-value">
                {vendaDetalhe?.created_at
                  ? Format.date(new Date(vendaDetalhe.created_at), 'DD/MM/YYYY HH:mm:ss')
                  : '---'}
              </span>
            </div>
            <div className="footer-item">
              <span className="footer-label">Total</span>
              <span className="total-value">{Format.formatCurrencyBr(vendaDetalhe?.total)}</span>
            </div>
          </S.DetailFooter>
        </Modal.Body>
      </Modal>
    </S.Container>
  );
}
